import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const ComplaintService = {
  getAllComplaints: async () => {
    try {
      const response = await axios.get(ENDPOINT.Complaint);
      return response.data;
    } catch (error) {
      console.error("Error fetching Complaints:", error.message);
      throw error;
    }
  },

getComplaintsByUser: async (uid) => {
    try {
      const response = await axios.get(`${ENDPOINT.Complaint}/user/${uid}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Complaints:", error.message);
      throw error;
    }
  },

  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    const response = await axios.post(`${ENDPOINT.Complaint}/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
},

  replyComplaint: async (id, data) => {
    try {
        const response = await axios.patch(`${ENDPOINT.Complaint}/reply/${id}`, data, {
            headers: { "Content-Type": "application/json" },
        });
        return response.data;
    } catch (error) {
        console.error("Error replying to Complaint:", error.message);
        throw error;
    }
},

updateComplaintStatus: async (id, data) => {
    try {
        const response = await axios.patch(`${ENDPOINT.Complaint}/status/${id}`, data, {
            headers: { "Content-Type": "application/json" },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating Complaint status:", error.message);
        throw error;
    }
},

  getComplaintById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.Complaint}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Complaint:", error.message);
      throw error;
    }
  },

  createComplaint: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.Complaint, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating Complaint:", error.message);
      throw error;
    }
  },

  updateComplaint: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.Complaint}/${id}`, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating Complaint:", error.message);
      throw error;
    }
  },

  deleteComplaint: async (id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.Complaint}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting Complaint:", error.message);
      throw error;
    }
  },
};